<template>
  <div class="container" ref="container">
    <!--顶部 筛选项-->
    <div class="lession_top">
      <div class="lession_top_left">
        <div class="back" @click="back">
          <img src="@/assets/icons/icon_fh.png" alt="" srcset="" />
          <span>{{ $t('back') }}</span>
        </div>
        <div>
          <a-select
            :placeholder="$t('selects.selectCourse')"
            style="width: 200px"
            v-model="searchData.lessonId"
            @change="getArrangeList"
            allowClear
          >
            <a-select-option :value="item.id" v-for="item of selectLessonList" :key="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </div>
        <div>
          <a-select
            style="width: 200px"
            :placeholder="$t('selects.selectClass')"
            v-model="searchData.classId"
            @change="getArrangeList"
            allowClear
          >
            <a-select-option :value="item.id" v-for="item of selectClassList" :key="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </div>
        <div>
          <a-select
            style="width: 200px"
            :placeholder="$t('selects.selectRoom')"
            v-model="searchData.trainingRoomId"
            @change="getArrangeList"
            allowClear
          >
            <a-select-option :value="item.id" v-for="item of selectRoomList" :key="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </div>
      </div>
      <div class="lession_top_right">
        <a-button icon="left" size="small" @click="prevWeek" />
        <div v-if="thisWeekStart === currentWeekStart.date" class="calendar-scope">
          {{ currentWeekStart.date }} - {{ currentWeekEnd.date }}
        </div>
        <div v-else class="calendar-scope">{{ currentWeekStart.date }} - {{ currentWeekEnd.date }}</div>
        <div>
          <a-button style="vertical-align: text-bottom" icon="right" size="small" @click="nextWeek" />
        </div>
        <div class="new_day" :class="{ noClick: thisWeekStart === currentWeekStart.date }" @click="nowDay">
          <span>{{ $t('calendar.today') }}</span>
        </div>
      </div>
    </div>
    <!-- 代办任务  日程表 -->
    <div class="top">
      <div class="tabs" style="width: 100%">
        <img src="@/assets/icons/arrange_time.png" alt="" />
        <FullCalendar ref="fullCalendar" :options="calendarOptions" class="demo-app-calendar" height="600">
          <template v-slot:eventContent="arg">
            <div
              class="eventContent"
              :class="arg.event.extendedProps.state + 'State'"
              @mouseenter="eventInfo"
              @mouseleave="hideEventInfo"
            >
              <div class="state">{{ getStateText(arg.event.extendedProps.state) }}</div>
              <div class="title">{{ arg.event.extendedProps.lessonName }}</div>
              <div class="time">
                <img src="@/assets/img/icon_time.png" alt="" />
                <span>{{ arg.event.extendedProps.time }}</span>
              </div>
              <div class="eventInfo">
                <div class="state">{{ getStateText(arg.event.extendedProps.state) }}</div>
                <div class="title">{{ arg.event.extendedProps.lessonName }}</div>
                <div class="list">
                  <img src="@/assets/img/icon_time.png" alt="" />
                  <span>{{ arg.event.extendedProps.time }}</span>
                </div>
                <div class="list">
                  <img src="@/assets/img/arrange_class.png" alt="" />
                  <span>{{ arg.event.extendedProps.className }}</span>
                </div>
                <div class="list" v-if="arg.event.extendedProps.trainingRoomId !== '0'">
                  <img src="@/assets/img/arrange_room.png" alt="" />
                  <span>{{ arg.event.extendedProps.trainingRoomName }}</span>
                </div>
                <div class="list" v-if="arg.event.extendedProps.trainingRoomId !== '0'">
                  <img src="@/assets/img/arrange_site.png" alt="" />
                  <span>{{ arg.event.extendedProps.trainingRoomPlace }}</span>
                </div>
                <div class="operation" v-if="arg.event.extendedProps.state === 'noStart'">
                  <img src="@/assets/img/arrange_edit.png" alt="" @click="edit(arg.event.extendedProps)" />
                  <img
                    src="@/assets/img/arrange_delete.png"
                    alt=""
                    @click="deleteArrange(arg.event.extendedProps.id)"
                  />
                </div>
                <div class="attendclass" v-if="arg.event.extendedProps.type === '1'">
                  <a-button size="small" style="float: right;" @click="startClassNow(arg.event.extendedProps.lessonId, arg.event.extendedProps.prepareLessonId)">
                    上课 >
                  </a-button>
                </div>
              </div>
            </div>
          </template>
        </FullCalendar>
      </div>
    </div>
    <div class="add" @click="add" ref="addButton">
      <img :class="`${this.$i18n.locale}`" :src="require(`@/assets/${this.$i18n.locale}/add_arrange.png`)" alt="" />
    </div>
    <a-modal
      :title="currentId ? $t('modal.editArrange') : $t('modal.addArrange')"
      width="515px"
      :visible="editShow"
      @ok="submitEdit"
      @cancel="editShow = false"
    >
      <a-form :form="formEdit">
        <a-form-item :label="$t('lessonArrange.course')">
          <a-select
            :placeholder="$t('lessonArrange.selectCourse')"
            v-decorator="['prepareLessonId', { rules: [{ required: true, message: $t('lessonArrange.selectCourseMessage') }] }]"
          >
            <a-select-option :value="item.id" v-for="item of lessonList" :key="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :label="$t('form.courseTitle.label')">
          <a-input
            :placeholder="$t('form.courseTitle.placeholder')"
            v-decorator="[
              'title',
              {
                rules: [
                  {
                    required: true,
                    message: $t('form.courseTitle.required')
                  }
                ]
              }
            ]"
          />
        </a-form-item>

        <a-form-item :label="$t('form.teachingClass.label')">
          <a-select
            :placeholder="$t('form.teachingClass.placeholder')"
            v-decorator="[
              'classId',
              {
                rules: [
                  {
                    required: true,
                    message: $t('form.teachingClass.required')
                  }
                ]
              }
            ]"
          >
            <a-select-option :value="item.id" v-for="item of classList" :key="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item :label="$t('form.startTime.label')">
          <a-date-picker
            style="width: 100%;"
            valueFormat="YYYY-MM-DD HH:mm:ss"
            format="YYYY-MM-DD HH:mm:ss"
            :placeholder="$t('form.startTime.placeholder')"
            v-decorator="[
              'startTime',
              {
                rules: [
                  {
                    required: true,
                    message: $t('form.startTime.required')
                  }
                ]
              }
            ]"
            show-time
            :disabled-date="disabledStartDate"
            :disabledTime="disabledStartTime"
          />
        </a-form-item>

        <a-form-item :label="$t('form.endTime.label')">
          <a-date-picker
            style="width: 100%;"
            valueFormat="YYYY-MM-DD HH:mm:ss"
            format="YYYY-MM-DD HH:mm:ss"
            :placeholder="$t('form.endTime.placeholder')"
            v-decorator="[
              'endTime',
              {
                rules: [
                  {
                    required: true,
                    message: $t('form.endTime.required')
                  }
                ]
              }
            ]"
            :disabled-date="disabledEndDate"
            :disabledTime="disabledEndTime"
            @change="changeEndTime"
            show-time
          />
        </a-form-item>
        <a-form-item :label="$t('form.courseType.label')">
          <a-select
            :placeholder="$t('form.courseType.placeholder')"
            :disabled="currentId ? true : false"
            v-decorator="['type', { rules: [{ required: true, message: $t('form.courseType.required') }] }]"
          >
            <a-select-option value="1">
              {{ $t('form.courseType.online') }}
            </a-select-option>
            <a-select-option value="2">
              {{ $t('form.courseType.offline') }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <div class="list_flex">
          <div class="wd205">
            <a-form-item :label="$t('form.trainingRoom.label')">
              <a-select
                :placeholder="$t('form.trainingRoom.placeholder')"
                v-decorator="[
                  'trainingRoomId',
                  {
                    rules: [
                      {
                        message: $t('form.trainingRoom.required')
                      }
                    ]
                  }
                ]"
                @change="changeRoom"
                allowClear
              >
                <a-select-option 
                  :value="item.trainingRoomId" 
                  v-for="item of roomList" 
                  :key="item.trainingRoomId"
                >
                  {{ item.trainingRoomName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </div>
          <div class="wd205">
            <a-form-item :label="$t('form.location.label')">
              <a-input 
                v-model="formDesc.site" 
                :placeholder="$t('form.location.placeholder')" 
                disabled 
              />
            </a-form-item>
          </div>
        </div>
      </a-form>
    </a-modal>
    <TipModal
      @ok="del"
      :visible="delVisible"
      @cancel="delVisible = false"
      :desc="`
        <p>${$t('deleteConfirm.title')}</p>
        <p class='placeholder'>${$t('deleteConfirm.warning')}</p>`"
    />
  </div>
</template>
<script>
import dayjs from 'dayjs'
import FullCalendar from '@fullcalendar/vue'
import timeGridPlugin from '@fullcalendar/timegrid'
import zhCnLocale from '@fullcalendar/core/locales/zh-cn'
import TipModal from '@/components/tipModal/index.vue'
import { classMap, prepareLessonList } from '@/api/lesson'
import { arrangeRoom, arrangeSave, arrangeDelete, arrangeList, arrangeFilter } from '@/api/admin.js'
import moment from 'moment'

export default {
  name: 'LessonArrange',
  components: {
    FullCalendar,
    TipModal
  },
  data() {
    return {
      thisWeekStart: '',
      currentYMD: dayjs().format('YYYY-M-D'),
      currentWeekStart: {},
      currentWeekEnd: {},
      weekList: new Array(7).fill(0).map(() => ({ date: 0, ymd: '' })),
      calendarOptions: {
        plugins: [
          // 加载插件，V5采用插件模块方式加入
          timeGridPlugin
        ],
        slotDuration: '01:00:00',
        slotMinTime: '06:00:00',
        slotMaxTime: '24:00:00',
        allDaySlot: false,
        slotLabelContent: function(arg) {
          return arg.date.getHours() + ':00' // 自定义时间格式
        },
        dayHeaderContent: arg => {
          const date = arg.date
          // 获取月份和日期
          const month = date.getMonth() + 1
          const day = date.getDate()

          // 获取星期几
          const dayOfWeek = this.daysOfWeek[date.getDay()]

          // 格式化日期
          return {
            html: `${dayOfWeek} <br/> ${month > 9 ? month : `0${month}`}.${day}`
          }
        },
        // dayHeaderFormat: {  weekday: 'long' },
        headerToolbar: {
          // 头部toolba
          left: '',
          center: '',
          right: ''
          // right: 'dayGridMonth'
        },
        handleWindowResize: true, // 随浏览器窗口变化
        initialView: 'timeGridWeek', // 初始化插件显示
        height: 650,
        // initialDate:""//初始化日期
        // initialEvents: INITIAL_EVENTS, // alternatively, use the `events` setting to fetch from a feed
        // droppable: true,//可拖拽的
        // timeZone: 'local',//采用时区
        selectable: false,
        // selectMirror: true,
        dayMaxEvents: true,
        // weekends: true, // 是否显示一周七天
        // select: this.handleDateSelect,
        // eventClick: this.handleEventClick, // 日程点击事件
        eventMouseEnter: this.handleEventMouseEnter, // 用户将鼠标悬停在事件上时触发
        // eventsSet: this.handleEvents,
        // dateClick: this.handleDateClick,//日期方格点击事件
        // eventClick: this.handleEventClick, //日程点击事件
        locale: zhCnLocale,
        nextDayThreshold: '01:00:00',
        events: []
      },
      daysOfWeek: [
        this.$t('weekdays.sunday'),
        this.$t('weekdays.monday'), 
        this.$t('weekdays.tuesday'),
        this.$t('weekdays.wednesday'),
        this.$t('weekdays.thursday'),
        this.$t('weekdays.friday'),
        this.$t('weekdays.saturday')
      ],
      editShow: false,
      formEdit: this.$form.createForm(this),
      formDesc: {
        class: '',
        time: '',
        site: ''
      },
      searchData: {},
      lessonList: [],
      roomList: [],
      selectLessonList: [],
      selectRoomList: [],
      selectClassList: [],
      delVisible: false,
      classList: []
    }
  },
  mounted() {
    this.initData()
    this.setCreateDate()
    this.setDateHeight()
    this.buttonDynamic()
    this.getClassList()
    this.getLessonList()
  },
  methods: {
    moment,
    back() {
      this.$router.go(-1)
    },
    // 按钮动效
    buttonDynamic() {
      this.$refs.addButton.classList.toggle('active')
    },
    initData() {
      this.weekStart = dayjs()
        .startOf('week')
        .add(1, 'days')
      this.thisWeekStart = this.weekStart.format('MM.DD')
      this.currentWeekStart.date = this.weekStart.format('MM.DD')
    },
    // 回到本周
    nowDay() {
      if (this.thisWeekStart === this.currentWeekStart.date) return
      this.weekStart = dayjs()
        .startOf('week')
        .add(1, 'days')
      this.setCreateDate()
      this.$refs.fullCalendar.getApi().today()
      // var events = []
      // this.$refs.fullCalendar.getApi().setOption('events', events)
    },
    selectDay(item) {
      console.log(item)
    },
    setWeekList() {
      const weekList = this.weekList
      if (this.currentWeekStart.day < this.currentWeekEnd.day) {
        let j = 0
        for (let i = weekList.length; i > 0; i--) {
          weekList[i - 1].date = this.currentWeekEnd.day - j
          weekList[i - 1].ymd = `${this.currentWeekEnd.year}-${this.currentWeekEnd.month}-${weekList[i - 1].date}`
          j++
        }
      } else {
        const middleIndex = 7 - this.currentWeekEnd.day
        let j = 0
        for (let i = weekList.length; i > middleIndex; i--) {
          weekList[i - 1].date = this.currentWeekEnd.day - j
          weekList[i - 1].ymd = `${this.currentWeekEnd.year}-${this.currentWeekEnd.month}-${weekList[i - 1].date}`
          j++
        }
        for (let i = 0; i < middleIndex; i++) {
          weekList[i].date = this.currentWeekStart.day + i
          weekList[i].ymd = `${this.currentWeekStart.year}-${this.currentWeekStart.month}-${weekList[i].date}`
        }
      }
      this.$forceUpdate()
    },
    nextWeek() {
      this.weekStart = this.weekStart.add(7, 'days')
      this.setCreateDate()
      this.$refs.fullCalendar.getApi().next()
      // var events = []
      // this.$refs.fullCalendar.getApi().setOption('events', events)
    },
    prevWeek() {
      this.weekStart = this.weekStart.subtract(7, 'days')
      this.setCreateDate()
      this.$refs.fullCalendar.getApi().prev()
      // var events = []
      // this.$refs.fullCalendar.getApi().setOption('events', events)
    },
    setCreateDate() {
      this.currentWeekStart = {
        date: this.weekStart.format('MM.DD'),
        filterData: this.weekStart.format('YYYY-MM-DD'),
        year: this.weekStart.year(),
        month: this.weekStart.month() + 1,
        day: this.weekStart.date()
      }
      this.currentWeekEnd = {
        date: this.weekStart.add(6, 'days').format('MM.DD'),
        filterData: this.weekStart.add(6, 'days').format('YYYY-MM-DD'),
        year: this.weekStart.add(6, 'days').year(),
        month: this.weekStart.add(6, 'days').month() + 1,
        day: this.weekStart.add(6, 'days').date()
      }
      this.searchData = {}
      this.getSearchFilter()
      this.getArrangeList()
      this.setWeekList()
    },
    setDateHeight() {
      console.log(this.$refs.container.offsetHeight)
      const height = this.$refs.container.offsetHeight - 100
      this.$refs.fullCalendar.getApi().setOption('height', height)
    },
    eventInfo(data) {
      console.log(data)
      const el = data.srcElement
      // 找到el元素下class为eventInfo的元素
      console.log(el.querySelectorAll('.eventInfo'), el)
      const elSon = el.querySelectorAll('.eventInfo')
      for (let index = 0; index < elSon.length; index++) {
        const element = elSon[index]
        element.style.width = '120%'
        element.style.opacity = '1'
      }
      // 找到el的class为fc-day祖先元素
      var fcDayAncestor = el.closest('.fc-day')
      fcDayAncestor.style.zIndex = 2
      el.closest('.fc-timegrid-event-harness').style.zIndex = 2
    },
    hideEventInfo(data) {
      const el = data.srcElement
      // 找到el元素下class为eventInfo的元素
      const elSon = el.querySelectorAll('.eventInfo')
      for (let index = 0; index < elSon.length; index++) {
        const element = elSon[index]
        element.style.width = '100%'
        element.style.opacity = '0'
      }
      var fcDayAncestor = el.closest('.fc-day')
      fcDayAncestor.style.zIndex = 1
      el.closest('.fc-timegrid-event-harness').style.zIndex = 1
    },
    async getArrangeList() {
      console.log(this.currentWeekStart, this.currentWeekEnd)
      const res = await arrangeList({
        startDate: this.currentWeekStart.filterData,
        endDate: this.currentWeekEnd.filterData,
        ...this.searchData
      })
      this.formatArrangeData(res.data.list)
    },
    // 格式化排课数据
    formatArrangeData(data) {
      function formatTime(date) {
        const d = new Date(date)
        const hours = d
          .getHours()
          .toString()
          .padStart(2, '0')
        const minutes = d
          .getMinutes()
          .toString()
          .padStart(2, '0')

        return `${hours}:${minutes}`
      }

      const stateNameMap = {
        noStart: this.$t('eventContent.state.notStarted'),
        start: this.$t('eventContent.state.inProgress'),
        end: this.$t('eventContent.state.ended')
      }
      function checkTimePeriod(createdAt, endTime) {
        const now = new Date()
        const start = new Date(createdAt)
        const end = new Date(endTime)

        if (now < start) {
          return 'noStart'
        } else if (now >= start && now <= end) {
          return 'start'
        } else {
          return 'end'
        }
      }

      const events = []

      data.forEach(item => {
        const state = checkTimePeriod(item.startTime, item.endTime)
        events.push({
          title: item.lessonName,
          start: item.startTime,
          end: item.endTime,
          extendedProps: {
            ...item,
            state,
            stateName: stateNameMap[state],
            time: formatTime(item.startTime) + '-' + formatTime(item.endTime)
          }
        })
      })
      this.$refs.fullCalendar.getApi().setOption('events', events)
    },
    add() {
      this.currentId = null
      this.formEdit.resetFields()
      for (const key in this.formDesc) {
        this.formDesc[key] = ''
      }
      this.roomList = []
      this.editShow = true
    },
    edit(data) {
      console.log('data ----->', data)
      this.currentId = data.id
      this.lessonId = data.lessonId
      this.formDesc = {
        class: data.className,
        time: data.startTime + '-' + data.endTime.split(' ')[1],
        site: data.trainingRoomId === '0' ? '' : data.trainingRoomPlace
      }
      this.getArrangeRoom(data.startTime, data.endTime)
      this.editShow = true
      this.$nextTick(() => {
        this.formEdit.setFieldsValue({
          title: data.lessonName,
          classId: data.classId,
          startTime: data.startTime,
          endTime: data.endTime,
          prepareLessonId: data.prepareLessonId,
          type: data.type,
          trainingRoomId: data.trainingRoomId === '0' ? undefined : data.trainingRoomId
        })
      })
    },
    deleteArrange(id) {
      this.currentId = id
      this.delVisible = true
    },
    async del() {
      const res = await arrangeDelete({
        id: this.currentId
      })
      if (res.code === 200) {
        this.delVisible = false
        this.getArrangeList()
      }
    },
    // 操作排课
    submitEdit() {
      this.formEdit.validateFields(async (err, values) => {

        console.log('values', values)
        if (!err) {
          const data = Object.assign(values, {
            id: this.currentId || undefined,
            lessonId: (values.type === '1' && this.currentId) ? this.lessonId : undefined
          })
          console.log('data', data)
          const res = await arrangeSave(data)
          if (res.code === 200) {
            this.editShow = false
            this.searchData = {}
            this.getSearchFilter()
            this.getArrangeList()
            this.$message.success(this.$t('messages.saveSuccess'))
          } else {
            this.$message.error(this.$t('messages.saveFailed'))
          }
        }
      })
    },
    async getArrangeRoom(startTime, endTime) {
      const res = await arrangeRoom({
        startTime,
        endTime
      })
      this.roomList = res.data.list
    },
    changeLesson(id) {
      const lesson = this.lessonList.find(item => item.id === id)
      this.formDesc.class = lesson.className
      this.formDesc.time = lesson.startTime + '-' + (lesson.endTime.split(' ')[1] || lesson.endTime.split(' ')[0])
      this.formDesc.site = ''
      this.formEdit.setFieldsValue({
        trainingRoomId: undefined
      })
      this.getArrangeRoom(id)
    },
    changeRoom(id) {
      const room = this.roomList.find(item => item.trainingRoomId === id)
      this.formDesc.site = room && room.trainingRoomPlace
    },
    async getSearchFilter() {
      const res = await arrangeFilter({
        startDate: this.currentWeekStart.filterData,
        endDate: this.currentWeekEnd.filterData
      })
      this.selectLessonList = res.data.listLesson
      this.selectRoomList = res.data.listRoom
      this.selectClassList = res.data.listClass
    },
    getClassList() {
      classMap().then(res => {
        this.classList = res.data.list
      })
    },
    changeEndTime(val) {
      const startTime = this.formEdit.getFieldValue('startTime')
      console.log('startTime', startTime)
      console.log('changeEndTime', val)
      if (startTime && val) {
        this.getArrangeRoom(startTime, val)
      } else {
        this.roomList = []
      }
    },
    disabledStartDate(startValue = new Date().getTime()) {
      const currentTime = moment()
        .hours(0)
        .minutes(0)
        .seconds(0)
        .milliseconds(0)
      const endValue = this.formEdit.getFieldValue('endTime')
      const dayStart = moment(endValue).startOf('day')
      const nextDayStart = moment(endValue)
        .add(1, 'days')
        .startOf('day')
      if (!endValue) {
        return startValue.valueOf() < currentTime
      } else {
        return dayStart.valueOf() >= startValue.valueOf() || startValue.valueOf() >= nextDayStart.valueOf()
      }
    },
    disabledStartTime(startTime) {
      let endTime = this.formEdit.getFieldValue('endTime')
      endTime = endTime && typeof endTime === 'string' ? moment(endTime) : endTime
      const fortyFiveMinutesBefore = moment(endTime).subtract(30, 'minutes')
      const threeHoursBefore = moment(endTime).subtract(3, 'hours')
      return {
        disabledHours: () => {
          const disabledArr = []
          const currentHours = moment().hour()
          const endHours = endTime ? moment(endTime).hour() : undefined
          if (moment().isSame(startTime, 'days')) {
            for (let i = 24; i--; i <= 0) {
              if (i < currentHours) {
                disabledArr.push(i)
              }
              if (endTime && moment(endTime).isSame(startTime, 'days') && i > endHours) {
                disabledArr.push(i)
              }
            }
          } else {
            for (let i = 24; i--; i <= 0) {
              if (endTime && moment(endTime).isSame(startTime, 'days') && i > endHours) {
                disabledArr.push(i)
              }
            }
          }
          if (endTime) {
            for (let i = 1; i <= 24; i++) {
              if (
                i > fortyFiveMinutesBefore.hour() ||
                i < threeHoursBefore.hour() ||
                (i <= moment().hour() && moment().date() === endTime.date())
              ) {
                disabledArr.push(i)
              }
            }
          }
          return disabledArr
        },
        disabledMinutes: () => {
          const disabledArr = []
          const currentMinute = moment().minute()
          const endMinute = endTime ? moment(endTime).minute() : undefined
          if (moment().isSame(startTime, 'hours')) {
            for (let i = 60; i--; i <= 0) {
              if (i < currentMinute) {
                disabledArr.push(i)
              }
              if (endTime && moment(endTime).isSame(startTime, 'hours')) {
                disabledArr.push(i)
              }
            }
          }
          if (endTime) {
            if (startTime && startTime.hour() === fortyFiveMinutesBefore.hour()) {
              for (let i = 60; i--; i <= 0) {
                if (i > fortyFiveMinutesBefore.minute()) {
                  disabledArr.push(i)
                }
              }
            } else if (startTime && startTime.hour() > fortyFiveMinutesBefore.hour()) {
              for (let i = 60; i--; i <= 0) {
                disabledArr.push(i)
              }
            } else if (startTime && startTime.hour() === threeHoursBefore.hour()) {
              for (let i = 60; i--; i <= 0) {
                if (i < threeHoursBefore.minute()) {
                  disabledArr.push(i)
                }
              }
            }
          }
          return disabledArr
        }
      }
    },
    disabledEndTime(endTime = moment()) {
      let startTime = this.formEdit.getFieldValue('startTime')
      startTime = startTime && typeof startTime === 'string' ? moment(startTime) : startTime

      // 获取 30 分钟后的时间
      const fortyFiveMinutesLater = moment(startTime).add(30, 'minutes')
      // 获取 3 小时后的时间
      const newTime = moment(startTime).add(3, 'hours')
      const endOfDay = moment(startTime).endOf('day')
      // 判断是否在同一天
      const isSameDay = startTime.isSame(newTime, 'day')
      const threeHoursLater = moment(startTime).add(45, 'minutes')
      return {
        disabledHours: () => {
          const disabledArr = []
          const currentHours = moment().hour()
          const endHours = startTime ? moment(startTime).hour() : undefined
          if (moment().isSame(endTime, 'days')) {
            for (let i = 24; i--; i <= 0) {
              if (i < currentHours) {
                disabledArr.push(i)
              }
            }
          } else {
            for (let i = 24; i--; i <= 0) {
              if (endTime && moment(startTime).isSame(endTime, 'days') && i < endHours) {
                disabledArr.push(i)
              }
            }
          }
          if (startTime) {
            if (isSameDay) {
              for (let i = 1; i <= 24; i++) {
                if (i < fortyFiveMinutesLater.hour() || i > threeHoursLater.hour()) {
                  disabledArr.push(i)
                }
              }
            } else {
              // 当前选择日期和开始时间是同一天
              if (startTime.isSame(endTime, 'day')) {
                for (let i = 1; i <= 24; i++) {
                  if (i < fortyFiveMinutesLater.hour() || i > threeHoursLater.hour()) {
                    disabledArr.push(i)
                  }
                }
              } else {
                // 当前选择日期和开始时间不是同一天
                for (let i = 1; i <= 24; i++) {
                  if (i > newTime.hour()) {
                    disabledArr.push(i)
                  }
                }
              }
            }
          }
          return disabledArr
        },
        disabledMinutes: () => {
          const disabledArr = []
          const currentMinute = moment().minute()
          const starMinute = startTime ? moment(endTime).minute() : undefined
          if (moment().isSame(endTime, 'hours')) {
            for (let i = 60; i--; i <= 0) {
              if (i < currentMinute) {
                disabledArr.push(i)
              }
              if (startTime && moment(startTime).isSame(endTime, 'hours') && i < starMinute) {
                disabledArr.push(i)
              }
            }
          }
          if (startTime) {
            if (isSameDay) {
              if (endTime && endTime.hour() === fortyFiveMinutesLater.hour()) {
                for (let i = 60; i--; i <= 0) {
                  if (i < fortyFiveMinutesLater.minute()) {
                    disabledArr.push(i)
                  }
                }
              } else if (endTime && endTime.hour() < fortyFiveMinutesLater.hour()) {
                for (let i = 60; i--; i <= 0) {
                  disabledArr.push(i)
                }
              } else if (endTime && endTime.hour() === threeHoursLater.hour()) {
                for (let i = 60; i--; i <= 0) {
                  if (i > threeHoursLater.minute()) {
                    disabledArr.push(i)
                  }
                }
              }
            } else {
              if (startTime.isSame(endTime, 'day')) {
                if (endTime && endTime.hour() === fortyFiveMinutesLater.hour()) {
                  for (let i = 60; i--; i <= 0) {
                    if (i < fortyFiveMinutesLater.minute()) {
                      disabledArr.push(i)
                    }
                  }
                } else if (endTime && endTime.hour() < fortyFiveMinutesLater.hour()) {
                  for (let i = 60; i--; i <= 0) {
                    disabledArr.push(i)
                  }
                } else if (endTime && endTime.hour() === threeHoursLater.hour()) {
                  for (let i = 60; i--; i <= 0) {
                    if (i > threeHoursLater.minute()) {
                      disabledArr.push(i)
                    }
                  }
                }
              } else {
                if (endTime && endTime.hour() === newTime.hour()) {
                  for (let i = 60; i--; i <= 0) {
                    if (i > newTime.minute()) {
                      disabledArr.push(i)
                    }
                  }
                }
              }
            }
          }
          return disabledArr
        }
      }
    },
    disabledEndDate(endValue = new Date().getTime()) {
      const currentTime = moment()
        .hours(0)
        .minutes(0)
        .seconds(0)
        .milliseconds(0)
      const startValue = this.formEdit.getFieldValue('startTime')
      const dayStart = moment(startValue).startOf('day')
      const nextDayStart = moment(startValue)
        .add(3, 'hours')
        .add(1, 'days')
        .startOf('day')
      if (!startValue) {
        return endValue.valueOf() < currentTime
      } else {
        return dayStart.valueOf() >= endValue.valueOf() || endValue.valueOf() > nextDayStart.valueOf()
      }
    },
    getStateText(state) {
      const stateMap = {
        noStart: this.$t('eventContent.state.notStarted'),
        start: this.$t('eventContent.state.inProgress'),
        end: this.$t('eventContent.state.ended')
      }
      return stateMap[state] || ''
    },
    formatEventContent(event) {
      return {
        stateName: this.getStateText(event.state),
        lessonName: event.lessonName,
        time: event.time,
        className: event.className,
        trainingRoomName: event.trainingRoomName,
        trainingRoomPlace: event.trainingRoomPlace
      }
    },
    getLessonList() {
      prepareLessonList().then(res => {
        this.lessonList = res.data.list
      })
    },
    // 立即上课
    async startClassNow(lessonId, prepareLessonId) {
      // 开启全屏
      this.enterFullscreen()
      this.$router.push({
        name: 'teaching',
        query: {
          id: prepareLessonId,
          roomId: lessonId
        }
      })
    },
    enterFullscreen() {
      const element = document.documentElement // 选择整个文档
      if (element.requestFullscreen) {
        element.requestFullscreen()
      } else if (element.mozRequestFullScreen) {
        // Firefox
        element.mozRequestFullScreen()
      } else if (element.webkitRequestFullscreen) {
        // Chrome, Safari 和 Opera
        element.webkitRequestFullscreen()
      } else if (element.msRequestFullscreen) {
        // IE/Edge
        element.msRequestFullscreen()
      }
      this.isFullscreen = true
      console.log('请求进入全屏模式')
    }
  }
}
</script>

<style scoped lang="less">
.container {
  padding: 0 20px;
  height: calc(100vh- 45px) !important;
  overflow: hidden !important;
  .back {
    width: 80px;
    height: 34px;
    display: flex;
    cursor: pointer;
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    margin-bottom: 18px;
    border-radius: 25px;
    align-items: center;
    justify-content: center;
    border: 1px solid #d6d6d6;
    img {
      height: 10px;
      margin-right: 9px;
    }
  }
  .lession_top {
    padding-top: 45px;
    display: flex;
    justify-content: space-between;
    width: 100%;
  }

  .lession_top_left {
    display: flex;
    /deep/ .ant-select-selection--single {
      border-radius: 50px;
    }
  }
  .lession_top_left > div {
    margin-right: 22px;
  }
  .lession_top_right {
    display: flex;
    /deep/.ant-btn-icon-only.ant-btn-sm {
      width: 32px;
      height: 32px;
    }
    .calendar-scope {
      padding: 0 18px;
      font-weight: 600;
      font-size: 22px;
      color: #585858;
    }
    .new_day {
      margin-left: 6px;
      min-width: 32px;
      padding: 0 4px;
      height: 32px;
      background: #ffffff;
      border-radius: 4px;
      border: 1px solid #d8dce0;
      font-weight: 400;
      font-size: 14px;
      color: #585858;
      text-align: center;
      line-height: 32px;
      cursor: pointer;
      span {
      }
    }
    .noClick {
      color: #ededed;
      border-color: #ededed;
    }
  }
}
/deep/ .eventContent {
  width: 100%;
  height: 100%;
  position: relative;
  padding-left: 11px;
  text-align: left;
  &::before {
    content: '';
    position: absolute;
    width: 2px;
    height: 100%;
    left: 0;
    top: 0;
  }
  &:first-child {
    padding-top: 6px;
  }
  .state {
    font-size: 12px;
    font-weight: 600;
  }
  .title {
    font-weight: 500;
    font-size: 14px;
    color: #000000;
    line-height: 24px;
  }
  .time {
    display: flex;
    align-items: center;
    margin-top: 3px;
    > img {
      width: 14px;
      margin-right: 4px;
    }
    span {
      font-weight: 500;
      font-size: 12px;
      color: #787878;
    }
  }
  .eventInfo {
    position: absolute;
    left: -1px;
    top: -1px;
    width: 100%;
    min-height: 100%;
    opacity: 0;
    transition: all 0.3s;
    padding: 14px 11px;
    &::before {
      content: '';
      position: absolute;
      width: 2px;
      height: 100%;
      left: 0;
      top: 0;
    }
    .state {
      font-size: 12px;
      font-weight: 600;
    }
    .title {
      font-weight: 500;
      font-size: 14px;
      color: #000000;
      margin-top: 11px;
    }
    &:first-child {
      padding-top: 14px;
    }
    .list {
      display: flex;
      align-items: center;
      margin-top: 8px;
      > img {
        width: 14px;
        margin-right: 4px;
      }
      span {
        font-weight: 500;
        font-size: 12px;
        color: #787878;
      }
    }
    .operation {
      position: absolute;
      right: 11px;
      top: 14px;
      display: flex;
      align-items: center;
      img {
        width: 14px;
        margin-left: 10px;
      }
    }
    .attendclass {
      position: absolute;
      right: 11px;
      bottom: 14px;
      display: flex;
      align-items: center;
    }
  }
}
/deep/ .endState {
  background-color: #f8f7f7;
  &::before {
    background: #eaeaea;
  }
  .state {
    display: none;
  }
  .eventInfo {
    background-color: #f8f7f7;
    &::before {
      background: #eaeaea;
    }
  }
}
/deep/ .startState {
  background-color: #e2f1ec;
  &::before {
    background: #23b774;
  }
  .state {
    color: #23b774;
  }
  .title {
    color: #000000;
  }
  .time span {
    color: #787878;
  }
  .eventInfo {
    background-color: #e2f1ec;
    &::before {
      background: #23b774;
    }
    .state {
      color: #23b774;
    }
  }
}
/deep/ .noStartState {
  background-color: #fff7ef;
  &::before {
    background: #ef623d;
  }
  .state {
    color: #ff6d00;
  }
  .title {
    color: #000000;
  }
  .time span {
    color: #787878;
  }
  .eventInfo {
    background-color: #fff7ef;
    &::before {
      background: #ef623d;
    }
    .state {
      color: #ff6d00;
    }
  }
}
/deep/ .ant-input {
  color: #585858;
}
/deep/ .tabs {
  position: relative;
  > img {
    position: absolute;
    left: 17px;
    top: 46px;
    width: 16px;
    z-index: 2;
  }
  .fc-timegrid-event .fc-event-main {
    padding: 0;
  }
  .fc-theme-standard td {
    position: relative;
  }
  .fc-col-header-cell {
    position: relative;
    height: 65px;
    .fc-scrollgrid-sync-inner,
    a {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .fc-scrollgrid > thead {
    background-color: #edf2f6;
  }
  .fc-day {
    z-index: 1;
  }
  .fc-scroller {
    overflow: auto !important;
  }
  colgroup {
    background-color: #fff;
  }
  .fc .fc-timegrid-slot {
    height: 90px;
  }
  .fc-timegrid-event-harness-inset .fc-timegrid-event {
    border: none;
    background: none;
    box-shadow: none;
  }
  .fc-direction-ltr .fc-timegrid-col-events {
    margin: auto;
  }
  .fc-direction-ltr .fc-timegrid-slot-label-frame {
    text-align: center;
  }
  .fc .fc-timegrid-slot-label-cushion {
    font-weight: 600;
    font-size: 14px;
    color: #6b738c;
  }
  .fc .fc-timegrid-col.fc-day-today {
    background: none;
  }
}
.wd205 {
  width: 205px;
}
.list_flex {
  display: flex;
  justify-content: space-between;
}
/deep/ .ant-modal-body {
  padding-top: 10px;
}
/deep/ .ant-form-item {
  margin-bottom: 12px;
  .ant-form-item-label {
    > label {
      &::before {
        width: 10px;
        content: '*';
        opacity: 0;
      }
    }
    .ant-form-item-required::before {
      content: '*';
      opacity: 1;
    }
  }
}
/deep/ .ant-select-disabled .ant-select-selection {
  height: 34px;
  position: relative;
  font-size: 14px;
  top: -1px;
  .ant-select-selection__placeholder {
    line-height: 24px;
  }
}
.add {
  position: fixed;
  right: 30px;
  bottom: 46px;
  cursor: pointer;
  z-index: 3;
  img {
    height: 73px;
    transform: scale(1);
    transition: transform 0.3s ease-in-out;
  }
  img.en-US{
    height: 40px;
  }
}
.active {
  img {
    animation: pulseAndShake 1.5s ease-in-out 0s 3;
  }
}
@keyframes pulseAndShake {
  0%,
  100% {
    transform: scale(1) rotate(0deg);
  }
  25% {
    transform: scale(1.2) rotate(-10deg);
  }
  50% {
    transform: scale(1.2) rotate(10deg);
  }
  75% {
    transform: scale(1.2) rotate(-10deg);
  }
}
</style>
